// ============================================================
// FILE: resources/js/plugins/security.js
// USPATIH GO — Frontend Security Plugin
//
// Membaca konfigurasi dari window.SECURITY_CONFIG yang
// di-inject oleh Blade layout via config/security.php
//
// Saat DevTools / inspect element terdeteksi: DOM asli dihapus
// dan diganti "coding acak" agar struktur halaman tidak mudah
// di-copy dari panel Elements.
// ============================================================

(function () {
  const cfg = window.SECURITY_CONFIG || {};

  // ---- 1. Nonaktifkan klik kanan ----------------------------
  if (cfg.disableRightClick) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();

      if (cfg.rightClickMessage) {
        if (typeof window.toast === 'function') {
          window.toast(cfg.rightClickMessage, 'warning', 3000);
        } else {
          showSecurityTooltip(e, cfg.rightClickMessage);
        }
      }
      return false;
    });
  }

  // ---- 2. Nonaktifkan seleksi teks --------------------------
  if (cfg.disableTextSelect) {
    document.addEventListener('selectstart', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    const style = document.createElement('style');
    style.textContent = `
      body *:not(input):not(textarea):not([contenteditable="true"]) {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ---- 3. Nonaktifkan copy / cut ----------------------------
  if (cfg.disableCopy) {
    document.addEventListener('copy', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    document.addEventListener('cut', function (e) {
      const tag = e.target?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea') return true;
      e.preventDefault();
      return false;
    });

    document.addEventListener('keydown', function (e) {
      const isCtrl = e.ctrlKey || e.metaKey;
      const tag = e.target?.tagName?.toLowerCase();
      const isForm = tag === 'input' || tag === 'textarea';

      if (isCtrl && !isForm) {
        const blocked = ['c', 'x', 'u', 's'];
        if (blocked.includes(e.key.toLowerCase())) {
          e.preventDefault();
          return false;
        }
      }
    });
  }

  // ---- 4. Nonaktifkan DevTools + obfuscate DOM --------------
  if (cfg.disableDevtools) {
    document.addEventListener('keydown', function (e) {
      const isCtrlShift = (e.ctrlKey || e.metaKey) && e.shiftKey;
      if (
        e.key === 'F12' ||
        (isCtrlShift && ['i', 'j', 'c'].includes(e.key.toLowerCase()))
      ) {
        e.preventDefault();
        return false;
      }
    });

    const obfuscate = cfg.obfuscateOnDevtools !== false;
    let locked = false;
    let scrambleTimer = null;

    function randHex(n) {
      const chars = 'abcdef0123456789';
      let out = '';
      for (let i = 0; i < n; i++) out += chars[(Math.random() * chars.length) | 0];
      return out;
    }

    function randIdent(len) {
      const a = 'abcdefghijklmnopqrstuvwxyz';
      const b = a + '0123456789_';
      let s = a[(Math.random() * a.length) | 0];
      for (let i = 1; i < len; i++) s += b[(Math.random() * b.length) | 0];
      return s;
    }

    /** Bangun "source" palsu — terlihat seperti HTML/JS acak, bukan struktur asli */
    function buildScrambledSource(lines) {
      const chunks = [];
      const tags = ['div', 'section', 'span', 'main', 'aside', 'nav', 'article', 'ul', 'li', 'form'];
      for (let i = 0; i < lines; i++) {
        const tag = tags[(Math.random() * tags.length) | 0];
        const cls = `${randIdent(4)}_${randHex(6)}`;
        const id = `x${randHex(8)}`;
        if (i % 5 === 0) {
          chunks.push(
            `/* ${randHex(12)} */\nfunction ${randIdent(7)}(${randIdent(3)}){return 0x${randHex(6)}^${(Math.random() * 9999) | 0};}`
          );
        } else if (i % 3 === 0) {
          chunks.push(
            `<${tag} id="${id}" data-k="${randHex(16)}" class="${cls} ${randIdent(5)}">${randHex(24)}</${tag}>`
          );
        } else {
          chunks.push(
            `<${tag} class="${cls}" style="--v:${randHex(4)}" aria-hidden="true"><!-- ${randHex(20)} --></${tag}>`
          );
        }
      }
      return chunks.join('\n');
    }

    function wipeAndObfuscate() {
      if (locked && document.getElementById('_usp_obf_root')) {
        refreshScramble();
        return;
      }
      locked = true;

      try {
        // Hentikan Alpine / timers yang masih jalan sebaik mungkin
        if (window.Alpine?.stop) {
          try { window.Alpine.stop(); } catch (_) { /* ignore */ }
        }
      } catch (_) { /* ignore */ }

      // Hapus head scripts/styles yang bisa bocor struktur komponen
      try {
        document.querySelectorAll('script, link[rel="stylesheet"], style').forEach((el) => {
          if (el.id === '_usp_obf_style') return;
          try { el.remove(); } catch (_) { /* ignore */ }
        });
      } catch (_) { /* ignore */ }

      const msg = obfuscate
        ? 'Source protected — USPATIH GO'
        : 'Halaman tidak tersedia.';

      const scrambled = obfuscate ? buildScrambledSource(48) : '';

      document.documentElement.removeAttribute('class');
      document.body.replaceChildren();
      document.body.removeAttribute('class');
      document.body.style.cssText = 'margin:0;background:#0b1220;color:#7dd3c7;';

      const root = document.createElement('div');
      root.id = '_usp_obf_root';
      root.setAttribute('data-protected', randHex(32));

      if (obfuscate) {
        const style = document.createElement('style');
        style.id = '_usp_obf_style';
        style.textContent = `
          #_usp_obf_root{min-height:100vh;display:flex;flex-direction:column;font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace}
          #_usp_obf_banner{padding:14px 18px;background:#111827;color:#94a3b8;font-size:13px;border-bottom:1px solid #1f2937}
          #_usp_obf_code{flex:1;margin:0;padding:16px 18px;font-size:11px;line-height:1.45;white-space:pre-wrap;word-break:break-all;color:#34d399;opacity:.85;user-select:none;pointer-events:none}
        `;
        document.head.appendChild(style);

        const banner = document.createElement('div');
        banner.id = '_usp_obf_banner';
        banner.textContent = msg;

        const pre = document.createElement('pre');
        pre.id = '_usp_obf_code';
        pre.textContent = scrambled;

        root.appendChild(banner);
        root.appendChild(pre);
      } else {
        root.style.cssText =
          'display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#94a3b8';
        root.innerHTML = `<p>${msg}</p>`;
      }

      document.body.appendChild(root);

      if (obfuscate && !scrambleTimer) {
        scrambleTimer = setInterval(refreshScramble, 1800);
      }
    }

    function refreshScramble() {
      const pre = document.getElementById('_usp_obf_code');
      if (!pre) return;
      pre.textContent = buildScrambledSource(40 + ((Math.random() * 20) | 0));
      // Pastikan tidak ada node asli yang diselundupkan kembali
      const kids = Array.from(document.body.children);
      if (kids.length !== 1 || kids[0].id !== '_usp_obf_root') {
        wipeAndObfuscate();
      }
    }

    function isDevtoolsOpen() {
      const threshold = 160;
      const wide = window.outerWidth - window.innerWidth > threshold;
      const tall = window.outerHeight - window.innerHeight > threshold;
      if (wide || tall) return true;

      // Deteksi tambahan via console (beberapa browser)
      let opened = false;
      const probe = new Image();
      Object.defineProperty(probe, 'id', {
        get() {
          opened = true;
          return 'usp';
        },
      });
      try {
        // eslint-disable-next-line no-console
        console.log('%c', probe);
        console.clear?.();
      } catch (_) { /* ignore */ }
      return opened;
    }

    setInterval(function () {
      if (locked || isDevtoolsOpen()) {
        wipeAndObfuscate();
      }
    }, 900);
  }

  // ---- 5. Nonaktifkan drag & drop gambar --------------------
  if (cfg.disableImageDrag) {
    document.addEventListener('dragstart', function (e) {
      if (e.target?.tagName?.toLowerCase() === 'img') {
        e.preventDefault();
        return false;
      }
    });
  }

  // ---- 6. Nonaktifkan print ---------------------------------
  if (cfg.disablePrint) {
    document.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'p') {
        e.preventDefault();
        return false;
      }
    });

    const printStyle = document.createElement('style');
    printStyle.textContent = '@media print { body { display: none !important; } }';
    document.head.appendChild(printStyle);
  }

  function showSecurityTooltip(mouseEvent, message) {
    const old = document.getElementById('_sec_tooltip');
    if (old) old.remove();

    const tip = document.createElement('div');
    tip.id = '_sec_tooltip';
    tip.textContent = message;
    tip.style.cssText = `
      position: fixed;
      left: ${Math.min(mouseEvent.clientX + 10, window.innerWidth - 280)}px;
      top:  ${Math.min(mouseEvent.clientY + 10, window.innerHeight - 50)}px;
      background: rgba(30,41,59,.92);
      color: #fff;
      font-size: 13px;
      font-family: sans-serif;
      padding: 8px 14px;
      border-radius: 10px;
      z-index: 99999;
      pointer-events: none;
      box-shadow: 0 4px 16px rgba(0,0,0,.2);
      max-width: 260px;
      line-height: 1.4;
    `;
    document.body.appendChild(tip);
    setTimeout(() => tip.remove(), 2500);
  }
})();
